import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'episodeItem',
    'currentEpisodeItem',
    'displayAllEpisodesBtn',
  ];

  connect() {
    this.hideDisplayAllEpisodesBtn();
    const maxEpisodesToDisplayInitially = 3;
    let isCurrentEpisodeVisbile = false;
    let isAnyEpisodeItemHidden = false;

    this.episodeItemTargets.forEach(
      function (episodeItem, index) {
        const episodePart = index + 1;

        if (episodePart <= maxEpisodesToDisplayInitially) {
          if (this.currentEpisodeItemTarget == episodeItem) {
            isCurrentEpisodeVisbile = true;
          }
          return true;
        }

        if (isCurrentEpisodeVisbile) {
          this.hideEpisode(episodeItem);
          isAnyEpisodeItemHidden = true;
        }
      }.bind(this)
    );

    if (isAnyEpisodeItemHidden) {
      this.showDisplayAllEpisodesBtn();
    }
  }

  displayAllEpisodes(_event) {
    this.episodeItemTargets.forEach((element) => {
      element.style.display = null;
    });

    this.hideDisplayAllEpisodesBtn();
  }

  hideEpisode(node) {
    node.style.display = 'none';
  }

  hideDisplayAllEpisodesBtn() {
    this.displayAllEpisodesBtnTarget.style.display = 'none';
  }

  showDisplayAllEpisodesBtn() {
    this.displayAllEpisodesBtnTarget.style.display = 'inherit';
  }
}
